import React from "react";
import "./NavBar.css";
import { menu } from "../../data";
import helpers from "../../_helpers/helpers";

const NavBar = () => {
  return (
    <header className="navbar">
      <div className="navbar--box-1">
        <div>
          <img src={"/assets/images/logo.svg"} />
        </div>
        <nav className="navbar__mobile-menu">
          <button
            type="button"
            className="openBtn"
            onClick={helpers.openMenuDrawer}
          >
            <img src={"/assets/images/icons/hamburger.svg"} />
          </button>
        </nav>
        <nav className="navbar__tablet-menu">
          <ul className="navbar--ul">
            {menu.slice(0, 2).map((x) => (
              <li className="navbar--li" key={x}>
                <a href={`#${x}`} className="body-2 navbar__link">
                  {x}
                </a>
              </li>
            ))}
            <li className="navbar--li">
              <button
                className="body-2 navbar__link navbar__contact"
                onClick={helpers.openContactDrawer}
              >
                {menu[2]}
              </button>
            </li>
            <li>
              <a
                href={`https://d-resume-copy.netlify.app/`}
                className="body-2 navbar__link"
                target="_blank"
                rel="noreferrer"
              >
                {menu[3]}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
